
import {
  alpha,
  Box,
  CardMedia,
  Divider,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { getFileSize } from "src/shared/Utils/getFileSize";

import { FormatDateBR } from "src/shared/Utils/FormatDateBR";

import { HandleDownloadFiles } from "src/shared/Utils/HandleDownloadFiles";
import { DeleteIcon, Download, DriveFolderUploadIcon, PictureAsPdfIcon, RemoveRedEyeIcon } from "../Icons/Icons";
interface ICardPreviewFile {
  onClick?: () => void;
  title: string;
  url: string;
  type:
  | "application/pdf"
  | "image/WEBP"
  | "image/GIF"
  | "image/JPG"
  | "image/jpeg"
  | "image/png";
  size: number;
  created_at?: string;
  isDownload?: boolean;
  isView?: boolean;
  titlePreview?: string;
}
interface IIconPreview {
  url: string;

  type: string;
}

export const IconImagePreview = ({ type, url }: IIconPreview) => {
  return (
    <Tooltip title="Clique para abrir">
      {type.includes("image") ||
        type.includes("jpeg") ||
        type.includes("jpg") ? (
        <CardMedia
          component="img"
          image={url}
          sx={{
            height: "45px",
            cursor: "pointer",
            width: "45px",
            borderRadius: "8px",
            mr: "16px",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "45px",
            height: "45px",

            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            alignItems: "center",

            borderRadius: "8px",
            mr: "16px",
            background: (theme) => alpha(theme.palette.primary.main, 0.8),
          }}
        >
          {type.includes("pdf") ? (
            <PictureAsPdfIcon fontSize="medium" sx={{ color: "white" }} />
          ) : (
            <DriveFolderUploadIcon fontSize="medium" />
          )}
        </Box>
      )}
    </Tooltip>
  );
};

export const CardPreviewFile = ({
  isDownload = false,
  isView = false,
  created_at,
  onClick,
  title,
  size,
  type,
  url,
  titlePreview,
}: ICardPreviewFile) => {
  return (
    <CardCore
      elevation={2}
      sxStyle={{
        padding: "12px",
        margin: "8px 0",
        height: "4rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => window.open(url, "_blank")}
      >
        <IconImagePreview type={type} url={url} />
        <Box>
          <Typography sx={{ fontSize: ".8rem", mb: 0.7 }}>
            {titlePreview || title}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {created_at && (
              <Typography sx={{ fontSize: { xs: ".7rem", sm: ".8rem" } }}>
                {FormatDateBR(created_at)}
              </Typography>
            )}
            {created_at && <Divider orientation="vertical" flexItem />}
            <Typography sx={{ fontSize: { xs: ".7rem", sm: ".8rem" } }}>
              {getFileSize(size)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {isDownload && (
          <IconButton
            onClick={() => HandleDownloadFiles(url, title).then()}
            color="primary"
            sx={{
              boxShadow: "rgba(0, 0, 0, 0.144) 0px 3px 8px;",
              p: { xs: 0.5, sm: 1 },
            }}
          >
            <Download fontSize="small" />
          </IconButton>
        )}
        {isView && (
          <IconButton
            onClick={() => window.open(url, "_blank")}
            sx={{
              boxShadow: "rgba(0, 0, 0, 0.144) 0px 3px 8px",
              p: { xs: 0.5, sm: 1 },
            }}
          >
            <RemoveRedEyeIcon
              fontSize="small"
              sx={{ color: (theme) => theme.palette.primary.main }}
            />
          </IconButton>
        )}

        {onClick && (
          <IconButton
            onClick={onClick}
            color="error"
            sx={{
              boxShadow: "rgba(0, 0, 0, 0.144) 0px 3px 8px",
              p: { xs: 0.5, sm: 1 },
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </CardCore>
  );
};
